import { render, staticRenderFns } from "./item-img.vue?vue&type=template&id=c435bbd2&scoped=true&"
import script from "./item-img.vue?vue&type=script&lang=js&"
export * from "./item-img.vue?vue&type=script&lang=js&"
import style0 from "./item-img.vue?vue&type=style&index=0&id=c435bbd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c435bbd2",
  null
  
)

export default component.exports